import React from 'react';
import FormModeToggle from './FormModeToggle';
import { ToggleContainer } from './FormModeToggleStyles';
import { connect } from 'react-redux';
import { reloadPage } from '../../services/urlGeneratorService';

class ModeToggle extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      displayedFormMode: this.props.app.shownMode,
    }
    this.handleFormModeToggle = this.handleFormModeToggle.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.app.shownMode !== this.props.app.shownMode) {
      this.setState({ displayedFormMode: this.props.app.shownMode });
    }
  }

  handleFormModeToggle(newMode) {
    this.setState({
      displayedFormMode: newMode
    }, () => {
      const { provisions, isDraft, shownMode, formUuid, relatedUuid, ...rest } = this.props.app;
      setTimeout(reloadPage, 500, {
        ...rest,
        customParams: this.props.customParams,
        hostingElement: this.props.hostingElement,
        // toggled by this component:
        isDraft: newMode === 'draft',
        shownMode: newMode,
        relatedUuid: formUuid,
        formUuid: relatedUuid
      })
    });
  }

  render() {
    if (!this.props.app.shownMode) {
      return null;
    }
    return (
      <ToggleContainer>
        <FormModeToggle
          displayedFormMode={this.state.displayedFormMode}
          changeDisplayedMode={(mode) => this.handleFormModeToggle(mode)}
        />
      </ToggleContainer>
    )
  }
}

function mapStateToProps({ app, customParams, hostingElement }) {
  return {
    app,
    customParams,
    hostingElement
  }
}

export default connect(mapStateToProps, {})(ModeToggle);